import React, { useState } from 'react';
import { Box, Drawer, Card, CardContent, Typography, CardHeader, CircularProgress } from '@mui/material';
import api from "../../../../services/api";
import FormAddEditToolbar from "../../../../components/global/AddEditBar";
import { useNavigate } from 'react-router-dom';
import { useNotifier } from "muinotify";
import useSWR, { mutate } from 'swr';
import ErrorNotification from '../../../../components/ErrorNotification/ErrorNotification';
import * as yup from 'yup';
import CategoryItemForm from '../CategoryItemForm';

const validationSchema = yup.object().shape({
    p_id: yup.number().required('Το πεδίο είναι υποχρεωτικό').positive('Πρέπει να είναι θετικός αριθμός'),
    //pc_id: yup.number().required('Field is required').positive('Must be a positive number'),
    pci_descr: yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    pci_aa: yup.number().positive('Must be a positive number').nullable(true),
    pci_type: yup.number().required('Το πεδίο είναι υποχρεωτικό').positive('Πρέπει να είναι θετικός αριθμός'),
    pci_amount: yup.number().min(0, 'Πρέπει να είναι 0 ή θετικός αριθμόςr').nullable(true),
    pci_notes: yup.string().nullable(true),
});

const CategoryItemAdd = ({ onClose, prod_id, category_type_data }) => {
    const navigate = useNavigate();
    const { notifier } = useNotifier();
    const { data: productions_ed } = useSWR(`/productions`);
    const { data: item_category } = useSWR(`/production-category-item-type`);
    const { data: category_type } = useSWR(`/production-category-type`);
    const [drawerOpen, setDrawerOpen] = useState(true);

    const [state, setState] = useState({
        p_id: null,
        p_id: prod_id || null,
        pci_descr: null,
        pci_aa: null,
        pci_type: null,
        pci_amount: null,
        pci_notes: null,
        pc_type_id: category_type_data?.id || null,
    });

    const headerNames = {
        p_id: 'Production',
        //pc_id: 'Category',
        pci_descr: 'Description',
        pci_aa: 'AA',
        pci_type: 'Type',
        pci_amount: 'Amount',
        pci_notes: 'Notes'
    };

    const URL = 'production-category-item';
    const NAV_PATH = 'category_item';

    const [errorMessage, setErrorMessage] = useState();
    const [errors, setErrors] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    function updateField(fieldName, value) {
        setState({ ...state, [fieldName]: value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await validationSchema.validate(state, { abortEarly: false });
            setErrors({});
            setIsUpdating(true);
            api.post(`/${URL}/`, state)
                .then(response => {
                    mutate(`/${NAV_PATH}`);
                    notifier("Στοιχείο Κατηγορίας Παραγωγής δημιουργήθηκε.", { variant: "success" });
                    setDrawerOpen(false);
                    if (onClose) {
                        onClose();
                    } else {
                        navigate(-1);
                    }
                })
                .catch(error => {
                    setErrorMessage(error);
                    notifier(<ErrorNotification error={error} />, { variant: "error" });
                })
                .finally(() => {
                    setIsUpdating(false);
                });
        } catch (validationErrors) {
            const formattedErrors = {};
            validationErrors.inner.forEach((error) => {
                formattedErrors[error.path] = error.message;
            });
            setErrors(formattedErrors);
        }
    };

    const handleSave = () => {
        const form = document.getElementById(`${URL}-item-form`);
        if (form) {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };

    const handleCancel = () => {
        if (onClose) {
            onClose();
        } else {
            navigate(-1);
        }
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleCancel}
                PaperProps={{
                    style: {
                        width: '100%',
                        height: '100vh',
                        maxWidth: '800px',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                <Card
                    sx={{
                        width: '100%',
                        maxWidth: 800,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    {/* Header Section */}
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                        <CardHeader
                            title={
                                <Typography variant="h3" gutterBottom>
                                    Προσθήκη Στοιχείου Κατηγορίας Παραγωγής
                                </Typography>
                            }
                        />
                    </Box>

                    {/* Scrollable Content Section */}
                    <CardContent
                        sx={{
                            display: 'flex',
                            height: '100vh',
                            flexGrow: 1, // Allow this section to grow and shrink
                            overflowY: 'auto',
                            margin: 'auto',
                        }}
                    >
                        <form id={`${URL}-item-form`} onSubmit={handleSubmit}>
                            <CategoryItemForm
                                state={state}
                                errors={errors}
                                updateField={updateField}
                                headerNames={headerNames}
                                productions={productions_ed}
                                item_category={item_category}
                                category_type={category_type}
                                prod_id={prod_id}
                                category_type_data={category_type_data}
                            />
                        </form>
                        {isUpdating && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    zIndex: 1000,
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                    </CardContent>

                    {/* Toolbar (Footer Section) */}
                    <Box >
                        <FormAddEditToolbar
                            handleSave={handleSave}
                            handleCancel={handleCancel}
                        />
                    </Box>
                </Card>
            </Drawer >
        </>
    );
};

export default CategoryItemAdd;
